import { AppRemixIcon } from '@/layout/AppComponents';
import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const SaicaReportsDefaultWidget = (props) => (
  <DefaultWidgetTemplate
    module={props.module}
    route="user_module_saicaReport_home"
  />
);

export default SaicaReportsDefaultWidget;
